// extracted by mini-css-extract-plugin
export default {"financing":"financing--vpMZt","placeholder":"placeholder--EU4ow financing--vpMZt"};